import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import Request1cModel from "../../model/Request1cModel";


export class PageAdminEmailReplayStore {
    private rootStore: RootStore | undefined;

    public arUsers = [];

    public search = '';

    public error: string = '';
    public showNextStep: boolean = false
    public activeId: any = ''
    public userEmail: string = ''

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init = () => {

        this.arUsers = [];
        this.reload();
    }

    onReplayEmail = () => {
        if (window.confirm('Отправить повторно?')) {

        }
    }

    @action
    reload ()  {
        Request1cModel.findNotEmailConfirmed(this.setData, this.setError);
    }

    @action
    setData = (result: any) => {

        result.data.row.map((item: any) => {
            item.updatedAt = new Date(item.updatedAt);
            return item;
        });
        this.arUsers = result.data.row;
    }

    @action
    setShowNextStep = (value: boolean, id: any, email: string) => {
        this.showNextStep = value
        this.activeId = id
        this.userEmail = email
    }
    @action
    changeUserEmail = (newEmail: string) => {
        this.userEmail = newEmail
    }
    @action
    deleteUser = () => {
        if (window.confirm("Удалить пользователя ?")) {
            Request1cModel.deleteUser(this.activeId, this.setData, this.setError);
            this.showNextStep = false
            this.reload()
        }


    }
    @action
    updateUser = () => {
        if (window.confirm("Изменить логин ?")) {
            Request1cModel.updateUser(this.activeId, this.userEmail, this.setData, this.setError);
            this.showNextStep = false
            this.reload()
        }
    }
    @action
    sendEmailReplay = (userId: number) => {
        if (window.confirm("Отправить повторное подтверждение электронной почты?")) {
            Request1cModel.sendEmailReplay(userId, this.setData, this.setError);
        }
    }
    @action setError = (error: any) => {
        console.log(error);
    }

    @action onFilterUser = (e: any) => {
        this.search = e.target.value;
    }

}
